module.exports = __webpack_public_path__ + "static/img/anxun41.6bd5833c.png";